export { useOverlayPosition } from './web/overlays/src/useOverlayPosition';
//# sourceMappingURL=useOverlayPosition.web.js.map